var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-container"},_vm._l((_vm.filterNav(_vm.modules)),function(module,index){return _c('div',{key:index,staticClass:"module-item",style:({
            backgroundImage: `url(${module.cover})`,
            backgroundColor: 'white' // 默认白色背景
          })},[_c('div',{staticClass:"module-content"},[_c('h3',{staticClass:"module-title"},[_vm._v(_vm._s(module.name))]),_vm._v(" "),_c('div',{staticClass:"view-button",on:{"click":function($event){return _vm.handleClick(module)}}},[_vm._v("立即查看")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }